export default function formatUsername(user) {
  // noinspection JSUnresolvedVariable
  return `${user.firstname} ${user.lastname} (${user.username})`;
}
